import { render } from "./EstimatedCost.vue?vue&type=template&id=4d644749&scoped=true"
import script from "./EstimatedCost.vue?vue&type=script&lang=js"
export * from "./EstimatedCost.vue?vue&type=script&lang=js"

import "./EstimatedCost.vue?vue&type=style&index=0&id=4d644749&scoped=true&lang=less"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d644749"]])

export default __exports__